/**
 * Stable ids for project-file pipes. A batch stores the id of the pipe that
 * produced it. Rows created before pipes were recorded have no id.
 */

export const FFU_PIPE_ID = 'ffu' as const;

/** One OpenAI call. Same consolidation output, every source file attached. */
export const FFU_SINGLE_CALL_PIPE_ID = 'ffu-single-call' as const;

export const PROJECT_FILE_PIPE_IDS = [
  FFU_PIPE_ID,
  FFU_SINGLE_CALL_PIPE_ID,
] as const;

export type ProjectFilePipeId = (typeof PROJECT_FILE_PIPE_IDS)[number];

export type ProjectFilePipeKind = 'multi-step' | 'single-call';

export type ProjectFilePipe = {
  id: ProjectFilePipeId;
  label: string;
  kind: ProjectFilePipeKind;
};

export const PROJECT_FILE_PIPES: readonly ProjectFilePipe[] = [
  {
    id: FFU_PIPE_ID,
    label: 'FFU',
    kind: 'multi-step',
  },
  {
    id: FFU_SINGLE_CALL_PIPE_ID,
    label: 'FFU single call',
    kind: 'single-call',
  },
];

export const isProjectFilePipeId = (
  value: unknown,
): value is ProjectFilePipeId =>
  typeof value === 'string' &&
  (PROJECT_FILE_PIPE_IDS as readonly string[]).includes(value);

/** Label for a stored id. Missing ids stay unlabeled so older batches still render. */
export const projectFilePipeLabel = (
  pipeId: string | null | undefined,
): string | null => {
  if (pipeId == null || pipeId === '') return null;
  return PROJECT_FILE_PIPES.find((pipe) => pipe.id === pipeId)?.label ?? pipeId;
};

export const isSingleCallProjectFilePipe = (
  pipeId: string | null | undefined,
): boolean => pipeId === FFU_SINGLE_CALL_PIPE_ID;
